import { FormikErrors, FormikTouched } from 'formik';
import isNil from 'lodash/isNil';
import { Fields, Values } from './types';

export const hasError = (errors: FormikErrors<Values>, touched: FormikTouched<Values>, field: Fields): boolean =>
  !isNil(errors?.[field]) && !!touched[field];
